<template>
    <footer class="footer-bar">
        <div class="left">
            <b-link :to="$getUrl('landing-page')" v-if="landingPagePublished">{{ $t('foo.landing_page') }}</b-link>
            <b-link :to="$getUrl('catalog')">{{ $t('foo.catalog') }}</b-link>
            <b-link :to="$getUrl('about-subscription')">{{ $t('foo.about_subscription') }}</b-link>
            <b-link :to="$getUrl('cdb-dashboard')">{{ $t('foo.cdb_dashboard') }}</b-link>
            <b-link v-if="showCancellationEntry" :to="$getUrl('cancel-subscription')">{{ $t('cdb.subscription.cancelSubscription.title') }}</b-link>
        </div>
        <div class="right">
            <b-link v-if="showCookieConsent" id="cookieBannerHint" class="cookie--banner-hint">{{ $t('foo.cookies') }}</b-link>
            <b-link v-for="entry in entries" :key="entry" :to="$getUrl('content-page', { path: entry})">{{ $t(`foo.${entry}`) }}</b-link>
        </div>
    </footer>
</template>
<script>
    import {
        BLink
    } from "bootstrap-vue"
    export default {
        name: 'FooterBar',
        components: {
            BLink
        },
        computed: {
            landingPagePublished() {
                return this.$root.whitelabel.setting('landing_page_published')
            },
            entries(){
                return JSON.parse(this.$root.whitelabel.setting('footer_entries'))
            },
            showCancellationEntry(){
                return this.$root.whitelabel.setting('show_cancellation_menu_entry')
            },
            showCookieConsent(){
                return this.$root.whitelabel.setting('show_cookie_consent')
            },
        },
    }
</script>